import { resources, common } from '../../../gads'
import { Targets } from '../../..'
import { GadsFieldsRequired } from '../../../utils/global'

export namespace ReplaceBroadKeywordV2 {
    // The core data of the improvement, available in the front-end
    export interface Body {
        keyword_rn: string
        adgroup_rn: string
        adgroup_name: string
        campaign_rn: string
        campaign_name: string
        campaign_group_name: string
        performance_mode: Targets.PerformanceMode
        search_terms: string[]
        keyword_text: string
        keyword_cost: number
        keyword_clicks: number
        keyword_conversions: number
        keyword_conversion_value: number
        keyword_cpa?: number
        keyword_roas?: number
        keyword_roi?: number
        keyword_profit?: number
        keyword_current_bid: number
        keyword_is_manual_cpc: boolean
        campaign_group_target_set: boolean
        campaign_group_cpa_target_or_avg?: number
        campaign_group_roas_target_or_avg?: number
        campaign_group_has_non_broads: boolean
        broads_avg_cpa?: number
        non_broads_avg_cpa?: number
        broads_avg_roas?: number
        non_broads_avg_roas?: number
        broads_avg_profit?: number
        non_broads_avg_profit?: number
        window: number
    }

    // Metadata provided when pushing/adjusting improvement
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface ExtraDetails {}

    // Error codes
    export const Error = {
        KEYWORD_NO_LONGER_EXISTS: 'KEYWORD_NO_LONGER_EXISTS',
    } as const

    export type Error = (typeof Error)[keyof typeof Error]

    // Human readable error message, used by support
    export const ErrorReadable = {
        [Error.KEYWORD_NO_LONGER_EXISTS]:
            'The keyword we wanted to pause has already been deleted.',
    }

    export enum NoImprovementReason {
        no_search_campaigns_found = 'no_search_campaigns_found',
        no_broad_keywords_found = 'no_broad_keywords_found',
        no_campaign_groups_found = 'no_campaign_groups_found',
        no_eligible_keywords_found = 'no_eligible_keywords_found',
        not_enough_search_terms_found = 'not_enough_search_terms_found',
        is_google_grant_account = 'is_google_grant_account',
    }
}

// Data processing types, not explicitly related to core types
export interface WindowedCampaign {
    campaign: GadsFieldsRequired<resources.Campaign, 'resource_name' | 'targeting_setting'>
    metrics: GadsFieldsRequired<
        common.Metrics,
        'all_conversions' | 'clicks' | 'cost_micros' | 'all_conversions_value'
    >
    window: number
}

type DeepRequired<T> = Required<{ [P in keyof T]: DeepRequired<T[P]> }>
export interface WindowedKeyword {
    keyword_view: DeepRequired<Pick<resources.KeywordView, 'resource_name'>>
    ad_group_criterion: GadsFieldsRequired<
        resources.AdGroupCriterion,
        'keyword' | 'resource_name' | 'effective_cpc_bid_micros'
    >
    campaign: GadsFieldsRequired<
        resources.Campaign,
        'resource_name' | 'bidding_strategy_type' | 'name' | 'keyword_match_type'
    >
    ad_group: GadsFieldsRequired<resources.AdGroup, 'resource_name' | 'name' | 'targeting_setting'>
    metrics: GadsFieldsRequired<
        common.Metrics,
        'all_conversions' | 'clicks' | 'cost_micros' | 'all_conversions_value'
    >
    window: number
}

export interface BroadMetrics {
    cost: number
    all_conversions: number
    all_conversions_value: number
    window: number
}

export interface SearchTermsRaw {
    search_term_view: GadsFieldsRequired<resources.SearchTermView, 'search_term'>
    segments: GadsFieldsRequired<common.Segments, 'keyword'>
}
